import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { PageHero } from "@/components/SectionHeader";
import { ContactForm } from "@/components/ContactForm";
import { COMPANY } from "@/lib/siteData";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        testid="contact-hero"
        eyebrow="Contact Us"
        title="Let's talk."
        description="Reach out for product enquiries, technical questions, or supply discussions. Our team typically responds within one business day."
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-4 space-y-5">
          <InfoBlock
            testid="contact-info-address"
            icon={<MapPin size={20} />}
            title="Address"
            body={COMPANY.address}
          />
          <InfoBlock
            testid="contact-info-phone"
            icon={<Phone size={20} />}
            title="Phone"
            body={COMPANY.phone}
          />
          <InfoBlock
            testid="contact-info-email"
            icon={<Mail size={20} />}
            title="Email"
            body={
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-indigo-600 hover:underline"
              >
                {COMPANY.email}
              </a>
            }
          />
          <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-600">
              Office Hours
            </p>
            <p className="mt-2 text-slate-700">Mon – Sat · 9:00 AM – 6:00 PM IST</p>
            <p className="text-sm text-slate-500 mt-1">
              Closed on national holidays
            </p>
          </div>
        </aside>

        <div className="lg:col-span-8 bg-white border border-slate-100 rounded-2xl p-8 shadow-sm">
          <h2 className="font-display text-2xl sm:text-3xl uppercase font-bold text-slate-900">
            Send Us a Message
          </h2>
          <p className="text-slate-600 mt-2">
            Have a question or just want to say hello? We'd love to hear from
            you.
          </p>
          <div className="mt-8">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}

const InfoBlock = ({ icon, title, body, testid }) => (
  <div
    className="bg-white border border-slate-100 rounded-2xl p-6"
    data-testid={testid}
  >
    <div className="flex items-center gap-3 mb-3">
      <span className="w-10 h-10 rounded-lg gradient-accent-soft flex items-center justify-center text-indigo-600">
        {icon}
      </span>
      <h3 className="font-display text-base uppercase tracking-wider font-bold text-slate-900">
        {title}
      </h3>
    </div>
    <div className="text-slate-700 leading-relaxed text-sm">{body}</div>
  </div>
);
